import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import _ from 'lodash';
import { PLANT_ITEM_NEW_API_BASE_URL } from 'plantItemNew/constants/plantItemConstants';
import { formattedJsonToSubmit } from 'plantItemNew/utils/PlantItemNewFormatHelper';
import { clearForm } from './formSlice';

const initialState = {
  paymentLoading: false,
  paymentSuccess: false,
  paymentError: false,
  paymentReference: null,
  paymentDuplicate: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initIndividualPayment.pending, (state, action) => {
        state.paymentLoading = true;
        state.paymentSuccess = false;
        state.paymentError = false;
        state.paymentReference = null;
        state.paymentDuplicate = null;
      })
      .addCase(initIndividualPayment.rejected, (state, action) => {
        state.paymentLoading = false;
        state.paymentSuccess = false;
        state.paymentError = action.payload && action.payload.response && action.payload.response.data;
        state.paymentReference = null;
        state.paymentDuplicate = null;
      })
      .addCase(initIndividualPayment.fulfilled, (state, action) => {
        return {
          // paymentLoading should not be set to false here as page redirect starts right after.
          paymentSuccess: true,
          paymentError: false,
          paymentReference: null,
          paymentDuplicate: null,
          ...action.payload,
        };
      })
      .addCase(clearForm, () => {
        return initialState;
      });
  },
});

export const initIndividualPayment = createAsyncThunk('payment/initPayment', async (duration, { getState }) => {
  const {
    application,
    profile,
    applicantDetails,
    holderDetails,
    plantItems,
    referenceData,
    declaration,
    privacyCollection,
  } = getState();

  const data = formattedJsonToSubmit(
    application,
    duration,
    applicantDetails,
    holderDetails,
    plantItems,
    referenceData,
    declaration,
    privacyCollection,
  );

  const statedata = getState();
  // Do not send the oidc information to the api because it can cause security issue
  let copiedData = _.cloneDeep(statedata);

  delete copiedData.snswOidc;
  delete copiedData.passwordlessOidc;
  delete copiedData.referenceData;
  delete copiedData.plantDesignReferenceData;
  delete copiedData.application.savingApplication;
  delete copiedData.application.creatingApplication;
  delete copiedData.application.receivingApplication;

  copiedData.formattedApplication = { ...data };

  const resp = await axios.post(`${PLANT_ITEM_NEW_API_BASE_URL}/initpayment`, copiedData, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return resp.data;
});

export const paymentReducer = paymentSlice.reducer;
